"use client";

import { memo } from "react";
import { isToday, isYesterday, format } from "date-fns";

type Props = {
  date: Date;
  isFirst?: boolean;
};

function formatDividerDate(date: Date): string {
  if (isToday(date)) return "Today";
  if (isYesterday(date)) return "Yesterday";
  return format(date, "EEEE, MMMM d, yyyy");
}

function DateDivider({ date, isFirst = false }: Props) {
  if (isFirst) {
    return (
      <div className="flex justify-center px-5 pb-2 pt-1">
        <span className="rounded-full border border-border bg-popover px-3 py-0.5 text-xs font-medium text-muted-foreground">
          {formatDividerDate(date)}
        </span>
      </div>
    );
  }

  return (
    <div className="relative my-4 flex items-center px-5">
      <div className="flex-1 border-t border-border" />
      <span className="mx-3 flex-shrink-0 rounded-full border border-border bg-popover px-3 py-0.5 text-xs font-medium text-muted-foreground">
        {formatDividerDate(date)}
      </span>
      <div className="flex-1 border-t border-border" />
    </div>
  );
}

export default memo(DateDivider);
